class LoginRequest {
  username: string = "";
  password: string = "";
}

export default LoginRequest;
